import React, { useEffect, useReducer, useState } from 'react'
import { TreeSelect } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import { isEmpty } from 'lodash'
const { SHOW_CHILD } = TreeSelect

const FormatOperation = (state, action) => {
  switch (action.type) {
    case 'key_field':
      return state.map((parent, idxParent) => {
        const Key_parent = `0-${idxParent}`
        const handleArrayLV1 = []
        if (parent.children !== null) {
          parent.children?.map((childrenLV1, idxLV1) => {
            const Key_ChildrenLV1 = `0-${idxParent}-${idxLV1}`
            const state_childrenLV1 = {
              ...childrenLV1,
              key: Key_ChildrenLV1,
              disabled: false,
              children: null,
            }
            handleArrayLV1.push(state_childrenLV1)
          })
        }
        const state_parent = {
          ...parent,
          key: Key_parent,
          disabled: true,
          children: handleArrayLV1.length === 0 ? null : handleArrayLV1,
        }
        return state_parent
      })
    default:
      return state
  }
}

const Oper = (props) => {
  const {
    setChoiceSubOperation,
    setChoiceOperation,
    choiceCompany,
    choiceOperation,
    choiceSubOperation,
    masterData,
    selectedOperationData,
    defaultOperationName,
    setAccountOptions,
    RebaseCutterFunctionally,
    disabled,
  } = props
  const [operationFilter, dispatcher] = useReducer(FormatOperation, masterData)
  const [operation, dispatch] = useReducer(FormatOperation, operationFilter)
  const [treeData, setTreeData] = useState()
  let url_page = window.location.pathname

  const defaultOperationNames = String(defaultOperationName || '')
    .split(',')
    .map((item) => item.trim())
    .filter((item) => item)

  const getDefaultOperationLabel = (value) => {
    const selectedIndex = (choiceOperation || []).findIndex(
      (item) => item?.toString() === value?.toString(),
    )

    if (selectedIndex === -1) {
      return value
    }

    const operationName = defaultOperationNames[selectedIndex]
    if (!operationName) {
      return value
    }

    return operationName
  }

  const getSelectedOperationLabel = (value) => {
    const selectedItem = selectedOperationData?.find(
      (item) => item?.id?.toString() === value?.toString(),
    )

    if (selectedItem) {
      const operationName =
        selectedItem.operation_name || selectedItem.name_th || selectedItem.name
      return operationName
    }

    return getDefaultOperationLabel(value)
  }

  const getTagDisplayLabel = (label, value) => {
    const hasLabel = label !== undefined && label !== null && label !== ''
    if (hasLabel) {
      const isPrimitiveLabel = ['string', 'number'].includes(typeof label)
      if (!isPrimitiveLabel) {
        return label
      }

      const labelText = String(label).trim()
      const valueText = String(value).trim()

      // When label is the same as value, it usually means no matched node in treeData.
      if (labelText !== valueText) {
        return label
      }
    }

    return getSelectedOperationLabel(value)
  }

  const renderTag = (event, labelText) => {
    const { closable, onClose } = event

    return (
      <span
        className="ant-select-selection-item"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          maxWidth: '100%',
        }}
      >
        <span className="ant-select-selection-item-content">{labelText}</span>
        {closable ? (
          <span
            className="ant-select-selection-item-remove"
            onMouseDown={(e) => e.preventDefault()}
            onClick={onClose}
            role="button"
            tabIndex={0}
          >
            <CloseOutlined />
          </span>
        ) : null}
      </span>
    )
  }

  useEffect(() => {
    if (masterData) {
      dispatch({ type: 'key_field', payload: operation, companyListID: choiceCompany })
    }
  }, [masterData, choiceCompany])
  useEffect(() => {
    setTreeData(operation)
  }, [operation])

  useEffect(() => {
    const newListOperations = operation.filter((item) => {
      if (choiceCompany?.includes(item?.value)) {
        return item
      }
    })
    setTreeData(newListOperations)
    if (newListOperations.length !== 0) {
      const arraySelected = []
      newListOperations?.map((item) => {
        item.children?.map((child) => {
          if (choiceOperation?.includes(child?.value)) {
            arraySelected.push(child.value)
          }
        })
      })
      setChoiceOperation(arraySelected)
    }
  }, [choiceCompany, operation])

  function onChange(value) {
    setAccountOptions([])
    setChoiceOperation(value)
    RebaseCutterFunctionally('from operation', choiceCompany, value, choiceSubOperation)
    if (value.length === 0) {
      setChoiceSubOperation([])
    }
  }

  const tProps = {
    treeData, // can fixed syntax "treeData"
    value: choiceOperation,
    onChange: onChange,
    treeCheckable: true,
    showCheckedStrategy: SHOW_CHILD,
    placeholder: 'Select Operation',
    style: {
      width: '100%',
    },
  }

  return !url_page.includes('/management/powerbi') &&
    !url_page.includes('/create-project') &&
    !url_page.includes('/information') ? (
    <TreeSelect
      disabled={isEmpty(choiceCompany)}
      size="large"
      treeDefaultExpandAll={true} //เปิด Children ทุกอัน ตอนเริ่มต้น
      {...tProps}
      maxTagCount={0}
      maxTagPlaceholder={(event) => {
        return event[0].label
      }}
      tagRender={(event) => {
        const { label, value } = event
        if (choiceOperation?.length > 1) {
          return renderTag(event, 'Multi select operation')
        }
        return renderTag(event, getTagDisplayLabel(label, value))
      }}
    />
  ) : (
    <TreeSelect
      size="large"
      // treeDefaultExpandedKeys={expandkeys}
      treeDefaultExpandAll={true} //เปิด Children ทุกอัน ตอนเริ่มต้น
      {...tProps}
      disabled={disabled}
      tagRender={(event) => {
        const { label, value } = event
        return renderTag(event, getTagDisplayLabel(label, value))
      }}
    />
  )
}

export default Oper
